import axios from 'axios';

export const updateCardIntent = async (customerId: string) => {
  const { data: clientSecret } = await axios.post<{ clientSecret: string }>(
    `/billing/card_intent`,
    {
      params: {
        customerId,
      },
    },
  );

  return clientSecret;
};
